import React, { useState } from 'react'
import { AssetInterface } from '../../../../../models/AssetModel/Asset';
import { useDarkModeStore } from '../../../../../store/useDarkModeStore';
import { useLanguageStore } from '../../../../../store/useLanguageStore';
import { darkModeBackgroudInputs } from '../../../../../utils/constants';
import AddHomeWorkIcon from '@mui/icons-material/AddHomeWork';
import ToastMessage from '../../../../../common/ToastMessage';
import useUpdateAsset from '../../../../../store/ReactQueries/assets/asset/useUpdateAsset';
import useAssetTypes from '../../../../../store/ReactQueries/assets/assetTypes/useAssetTypes';

interface SelectTypeProps {
    typeId: string;
    asset: AssetInterface | undefined;
    page: number;
    pageSize: number;
}

export const SelectType: React.FC<SelectTypeProps> = ({ asset, typeId, page, pageSize }) => {

    const { language } = useLanguageStore();
    const { darkMode } = useDarkModeStore();
    const { data: types } = useAssetTypes(0, 0);

    const updateAsset = useUpdateAsset(page, pageSize);

    const [selectedItem, setSelectedItem] = useState<string>(typeId);

    const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { value } = e.target;
        if (asset) {
            const { id, barcode, assetCategoryId, title, assetTypeId, description, locationId, assetDepartmentId, assetStatusId, price, companyId } = asset;
            setSelectedItem(value);
            const upForm: AssetInterface = {
                id,
                barcode,
                assetCategoryId,
                title,
                assetTypeId: value,
                description,
                locationId,
                assetDepartmentId,
                assetStatusId,
                price,
                companyId,
            }
            updateAsset.mutate(upForm, {
                onSuccess: () => ToastMessage.Success(),
                onError: (error) => {
                    setSelectedItem(assetTypeId);
                    ToastMessage.Failed(error.message);
                }
            });
        }
    };

    return (
        <div className='d-flex flex-row align-items-center gap-1' title={language['AssetType']}>
            <AddHomeWorkIcon sx={{ width: 13, height: 13, color: darkMode ? 'white' : 'initial' }} />
            <select
                className='select-asset'
                style={{ color: darkMode ? 'white' : 'initial', background: darkMode ? darkModeBackgroudInputs : 'initial' }}
                value={selectedItem}
                onChange={(e) => {
                    e.preventDefault();
                    handleSelect(e);
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {types?.map(({ id, title }) => <option key={id} value={id}>{title}</option>)}
            </select>
        </div>
    )
}
export default SelectType;